import React, { useEffect, useState } from 'react'
import Paginator from 'components/Paginator'

const ListTable = ({ currentPage, searchQ, refreshTable, sort, propSelected, propSelectAll, toggleRow,
  toggleSelectAll, shareList, pages, getList }) => {

  const [currPage, setCurrPage] = useState(parseInt(currentPage) || 1)
  const [loading, setLoading] = useState(false)
  const [rownum, setRownum] = useState(20)

  useEffect(() => {
    setLoading(true)
    getList(currPage, searchQ)
  }, [refreshTable])

  const _onNext = (page) => {
    setLoading(true)
    getList(parseInt(page) + 1, searchQ)
    setCurrPage(parseInt(page) + 1)
  }

  const _onPrevious = (page) => {
    if (page !== 1) {
      setLoading(true)
      getList(parseInt(page) - 1, searchQ)
      setCurrPage(parseInt(page) - 1)
    }
  }

  if (shareList === undefined || shareList === null) {
    return null
  }

  const hasNext = currPage < pages

  return (
    <div className="bg-white shadow overflow-hidden sm:rounded-md">
      <ul className="divide-y divide-gray-200">
        {shareList.map((share) => {
          return (<li key={share.external_id}>
            <div className="px-4 py-4 sm:px-6">
              <div className="flex items-left justify-between">
                <div>
                  <div className='pretty p-default p-curve'>
                    <input
                      type='checkbox'
                      checked={propSelected[share.pk] === true}
                      onChange={() => toggleRow(share)}
                    />
                    <div className='state'>
                      <label />
                    </div>
                  </div>
                  <a href={'/shares/' + share.external_id + '/'} className="text-lg font-medium hover:text-blue-500 truncate">{share.title}</a>
                </div>
                <div className="ml-2 flex-shrink-0 flex">
                  <p className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                    {share.external_id}
                  </p>
                </div>
              </div>
              <div className="mt-2 md:grid md:grid-cols-3">
                <div className="sm:flex">
                  <p className="flex items-left text-sm text-gray-500">
                    <div className='table-asset-codes'>
                      <span>Collectors: </span><br />
                      {share.collectors.map((collector, idx) => {
                        return (
                          <a className='table-collector hover:text-blue-500' key={collector['pk']} href={`/${collector['set_type']}s/` + `${collector['external_id']}`}>{collector['name']}</a>
                        )
                      })}
                    </div>
                  </p>
                </div>
                <div className="sm:flex">
                  <p className="mt-2 flex items-left text-sm text-gray-500 sm:mt-0 sm:ml-6">
                    <div className='table-asset-codes'>
                      <span>Writers: </span><br />
                      {share.writers.map((writer, idx) => {
                        return (
                          <a className='table-writer hover:text-blue-500' key={writer['id']} href={'/writers/' + writer['external_id'] + '/'}>{writer['name']}</a>
                        )
                      })}
                    </div>
                  </p>
                </div>
                <div className="sm:flex">
                  <p className="mt-2 flex items-left text-sm text-gray-500 sm:mt-0 sm:ml-6">
                    <div className='table-asset-codes'>
                      <div className='table-asset-codes'>
                        <span><small>ISWC: </small>{share.iswc ? share.iswc : '---'}</span><br />
                        <span><small>HFA Code: </small>{share.hfa_code ? share.hfa_code : '---'}</span><br />
                        <span><small>Custom ID: </small>{share.custom_id ? share.custom_id : '---'}</span>
                      </div>
                    </div>
                  </p>
                </div>
              </div>
            </div>
          </li>)
        })}
      </ul>
      <div className="">
      < Paginator
          getNext={_onNext}
          getPrev={_onPrevious}
          currPage={currPage}
          setCurrPage={setCurrPage}
          hasNext={hasNext}
          totalPages={pages}
        />
      </div>
    </div>
  )
}

export default ListTable
